import useIsWidthBelow from './useIsWidthBelow';

const useIsMobile = () => {
  const isMobile = useIsWidthBelow(768);

  return isMobile;
};

export default useIsMobile;
